import React from 'react';
import './App.css';
import ContactForm from './pages/ContactForm';
// import ProjectGallery from './pages/ProjectGallery';
import CadSection from './pages/CadSection';
import SecondSection from './pages/SecondSection';
import ThirdSection from './pages/ThirdSection';
import ForthSection from './pages/ForthSection';
import EightSection from './pages/EightSection';
// import LastProjectsSection from './pages/LastProjectsSection';
// import FifthSection from "./pages/FifthSection";
// import SixthSection from './pages/SixthSection';
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
// import ProjectsGrid from './pages/ProjectsGrid';
// import FourImagesSection from './pages/FourImagesSection';

function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />

      <div className="spacer-top"></div>

      {/* Sections with IDs for smooth scroll */}
      <section id="catalogs">
        <CadSection />
      </section>

      <section id="diagrams">
        <SecondSection />
      </section>

      <section id="tags">
        <ThirdSection />
      </section>

      <section id="isodraft">
        <ForthSection />
      </section>

      <section id="design">
        {/* <FifthSection />
        <SixthSection /> */}
        <EightSection />
      </section>

      {/* <section id="projects">
        
        <ProjectGallery />
        <ProjectsGrid />
        <LastProjectsSection />
        <FourImagesSection />
      </section> */}

      {/* <div className="header">
        Let Our Experience help You in Your Project
      </div> */}

      <div className="spacer-bottom"></div>

      <section id="contact">
        <ContactForm />
      </section>

      <div className="spacer-bottom"></div>

      <div className="footer">
  <div className="footer-content">
    <img
      src="/assets/logo.jpg"
      alt="AHS Logo"
      className="footer-logo"
    />
    <span>© 2025 www.AHS</span>
  </div>
    </div>
    </div>
  );
}

export default App;
